import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// New page → top. Back/forward (POP) keeps the browser's restored position.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, navType]);
  return null;
};
